export const SIDEBAR_NAV = [
  { id: 'dashboard', label: 'Dashboard',      icon: 'Home'     },
  { id: 'nilscore',  label: 'NIL Score',      icon: 'Star'     },
  { id: 'analyzer',  label: 'Contracts',      icon: 'Contract' },
  { id: 'ghost',     label: 'Ghost Agent',    icon: 'Ghost'    },
  { id: 'scheduler', label: 'Post Scheduler', icon: 'Calendar' },
  { id: 'scanner',   label: 'Social Scanner', icon: 'Scanner'  },
  { id: 'earnings',  label: 'Earnings',       icon: 'Earnings' },
];

export const COMPONENT_TO_ROUTE = {
  dashboard:  '/dashboard',
  nilscore:   '/nil-score',
  analyzer:   '/contract-analyzer',
  scheduler:  '/post-scheduler',
  scanner:    '/social-scanner',
  ghost:      '/ghost-agent',
  earnings:   '/earnings',
  profile:    '/profile',
};

export const ROUTE_TO_COMPONENT = Object.fromEntries(
  Object.entries(COMPONENT_TO_ROUTE).map(([k, v]) => [v, k])
);
